module.exports = __webpack_public_path__ + "1.4.15-unryo/img/hyper-v.35a24838.png";